import React from "react";

const renderRankValue = enabled => {
  const color = enabled ? "green" : "red";

  return <i className={`teaser__dt_icon ${color}`} />;
};

const DeviceTarget = ({ mobile_enabled, desktop_enabled }) => {
  return (
    <div className="teaser__device-target">
      <div className="teaser__device-target-item">
        <i className="teaser__device-icon mobile" />{" "}
        {renderRankValue(mobile_enabled)}
      </div>
      <div className="teaser__device-target-item">
        <i className="teaser__device-icon desktop" />{" "}
        {renderRankValue(desktop_enabled)}
      </div>
    </div>
  );
};

export default DeviceTarget;
